import { VF_DATE_PICKER } from 'AppSrc/core/components/forms/form-base-components/v-f-date-picker';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE } from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';


const fieldId = CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE;

const validator = (params) => {
  const {
    values,
    field,
  } = params;
  const {
    optional,
  } = field;
  const value = values[fieldId];


  const { minDate, maxDate } = field.componentData.vFParams;
  const dateIsBeforeMin = commonValidation.date.isBeforeMinDate(value, minDate);
  const dateIsAfterMax = commonValidation.date.isAfterMaxDate(value, maxDate);


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(value, VF_DATE_PICKER);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  errors[INLINE_ERRORS].push(dateIsBeforeMin ? 'The scheduled start date can not be before the CRQ start date' : null);
  errors[INLINE_ERRORS].push(dateIsAfterMax ? 'The scheduled start date can not be after the CRQ end date' : null);

  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};

// This overwritten by the form :)
const initialValues = null;

const vFParams = {
  fieldTitle: 'Scheduled start date/time',
  displayType: 'big',
};

const uaScheduledStartDate = {
  id: fieldId,
  validator,
  vFParams,
  initialValues,
  fieldType: VF_DATE_PICKER,
};

export { uaScheduledStartDate };
